import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { isNull, isNullOrUndefined } from "../../../../utils/utilityFunctions";
import Ratings from "../../../../components/Ratings/Ratings";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";
import { useQuery } from "@tanstack/react-query";
import { getSovSomTable, getSovSomTrend } from "../../../../api/brandPerformanceApi";
import { RootStateOrAny, useSelector } from "react-redux";

interface Props extends RouteComponentProps {
  onHandleRadioClick: any;
  nissanCompetitor: string;
  diff: number;
  granularity: string;
}

const SovSomContent = withRouter((props: Props) => {
  const { diff, nissanCompetitor, onHandleRadioClick, history, granularity } = props;

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  const {
    data: sovSomTrendData,
    isFetching: loadingSovSomTrendData,
    refetch: refetchSovSomTrendData,
  } = useQuery(["sovSomTrendData", granularity, history.location.search], () => getSovSomTrend({ ...params, nissan_competitor: nissanCompetitor }), {
    enabled: false,
  });

  const {
    data: sovSomTableData,
    isFetching: loadingSovSomTableData,
    refetch: refetchSalesByVolumeTableData,
  } = useQuery(["sovSomTableData", granularity, history.location.search], () => getSovSomTable({ ...params, nissan_competitor: nissanCompetitor }), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchSovSomTrendData();
    refetchSalesByVolumeTableData();
  }, [history.location.search]);

  const columns = [
    {
      id: "model",
      Header: `Model`,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "SOV/SOM",
      accessor: `score`,
      id: "sov_som",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return isNullOrUndefined(value) ? "n/a" : `${value?.toLocaleString()}`;
      },
    },
    {
      Header: "YOY",
      accessor: `score_yoy`,
      id: "yoy",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return (
          <div className="cell-data">
            {isNullOrUndefined(value) ? "" : <Ratings value={value} isPercentageValue={false} testValue={false} />}
            {isNullOrUndefined(value) ? "n/a" : `${Math.abs(value).toFixed(1)}%`}
          </div>
        );
      },
    },
  ];

  return (
    <div className="brand-market-main-content">
      <BrandPerformanceTrendTile
        title="SOV/SOM Trend"
        chartId="sovSomTrendChart"
        chartData={sovSomTrendData}
        loadingTrend={loadingSovSomTrendData}
        diff={diff}
        nissanCompetitor={nissanCompetitor}
        onHandleRadioClick={onHandleRadioClick}
        showSOVchartText={true}
        chartGranularity={granularity}
      />
      <BrandPerformanceTableTile
        title="SOV/SOM average"
        tableId="sovSomTable"
        tableData={sovSomTableData}
        columns={columns}
        loadingTable={loadingSovSomTableData}
        initialSortCol={{ id: "model", desc: true }}
      />
    </div>
  );
});

export default SovSomContent;
